import {
  Component, EventEmitter, Input, Output, OnChanges, SimpleChanges,
} from '@angular/core';
import { BaseForm } from '@lc/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepper, MatStep, MatStepperPrevious, MatStepperNext } from '@angular/material/stepper';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { DynamicFormModel } from './dynamic-form.model';
import { DynamicForm, DynamicFormGroup } from './dynamic-form.form';
import { MultiselectComponent } from '../../inputs/multiselect/multiselect.component';
import { TextboxComponent } from '../../inputs/textbox/textbox.component';
import { CheckboxComponent } from '../../inputs/checkbox/checkbox.component';
import { TextareaComponent } from '../../inputs/textarea/textarea.component';
import { RadioGroupComponent } from '../../inputs/radio-group/radio-group.component';

@Component({
  selector: 'lc-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatStepper,
    MatStep,
    MultiselectComponent,
    TextboxComponent,
    CheckboxComponent,
    TextareaComponent,
    RadioGroupComponent,
    MatDivider,
    MatButton,
    MatStepperPrevious,
    MatStepperNext,
  ],
})
export class DynamicFormComponent implements OnChanges {
  @Input() model: DynamicFormModel;

  @Output() readonly saved = new EventEmitter<DynamicForm>();

  groupIndex = 0;
  group: DynamicFormGroup;
  readonly form = new DynamicForm();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model && this.model) {
      this.form.reset(this.model);
      this.groupIndex = 0;
      this.group = this.form.groups[0];
    }
  }

  onDone(group: DynamicFormGroup) {
    if (!group.valid) {
      return BaseForm.markAllAsDirty(group);
    }

    this.saved.emit(this.form);
  }
}
